/**
 * A helper class to get/set values from the local store
 */
export default class ConfigUtil {
    /** JB:
     * Might be useful to make a class for the config object. Then we can just load and save from that
     * Like, each item can be loaded from store, thats fine, but then we can have a better place for defaults
     */
    private static GetLocalStorageValue<T extends string | boolean | number>(key: string, defaultValue: T): string {
        // JB: what am i doing with my life
        let valueAsString = localStorage.getItem(key);
        if (valueAsString == null) {
            return defaultValue.toString();
        }
        return valueAsString;
    }

    /**
     * Gets or sets a value indicating that audio playback has been enabled/disabled
     */
    public static get AudioEnabled() {
        return this.GetLocalStorageValue("config_audio_enabled", true).toLowerCase() === "true" ? true : false;
    }
    public static set AudioEnabled(value: boolean) {
        localStorage.setItem("config_audio_enabled", value.toString());
    }
}



// WEBPACK FOOTER //
// ./src/utils/ConfigUtil.ts